// ENTORNO DE DESARROLLO - apunta a butaco-dev
// Para testear con datos reales de prod: descomentar el bloque PROD y comentar el de DEV
export const environment = {
  production: false,
  urlCheckCode: 'https://us-central1-butaco-prod-2a7be.cloudfunctions.net/publicFunc-checkCode',
  version: '1.10.8',
  documentFirebaseInterno: 'xkuJa4DiapRunCUtVMNf',
  documentFirebaseExterno: '8wAju89i61l8EnHigLpn',
  // PROD Firebase (comentado)
  // firebase: {
  //   emulator: false,
  //   apiKey: 'AIzaSyCo2EYg9pfcI1Y3MCUqtzFA8EXxgkYsMEM',
  //   authDomain: 'butaco-prod-2a7be.firebaseapp.com',
  //   projectId: 'butaco-prod-2a7be',
  //   storageBucket: 'butaco-prod-2a7be.appspot.com',
  //   messagingSenderId: '886779384888',
  //   appId: '1:886779384888:web:d96259988e92ef920c82cd',
  // },
  // DEV Firebase (activo)
  firebase: {
    emulator: false,
    apiKey: 'AIzaSyCFMgC-WUXqBZ-Fp2am87pHLczbY5yKhrs',
    authDomain: 'butaco-dev.firebaseapp.com',
    projectId: 'butaco-dev',
    storageBucket: 'butaco-dev.appspot.com',
    messagingSenderId: '688851361388',
    appId: '1:688851361388:web:7279277e8643d2664b8249',
    measurementId: 'G-4ZQ564RW1R',
  },
};
